import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AUTH_REQUIRED } from '../app.routes.paths';
import { AccountService } from '../services/account-service/account.service';
import { SessionService } from '../services/account-service/session.service';
import { RedirectService } from '../services/redirect-service/redirect.service';

export const accountGuard: CanActivateFn = async (_route, state) => {
  const accounts = inject(AccountService);
  const session = inject(SessionService);
  const redirects = inject(RedirectService);
  const router = inject(Router);

  if (await accounts.restoreSession()) {
    return true;
  }

  redirects.remember(state.url);
  const path = session.status() === 'unavailable' ? '/login/session' : '/login';
  return router.createUrlTree([path], { queryParams: redirects.queryParams });
};

export const accountChildGuard: CanActivateChildFn = (route, state) => accountGuard(route, state);

export const guestGuard: CanActivateFn = async route => {
  const accounts = inject(AccountService);
  const redirects = inject(RedirectService);
  const router = inject(Router);
  if (route.queryParamMap.has('returnUrl')) {
    redirects.remember(route.queryParamMap.get('returnUrl'));
  }

  if (!await accounts.restoreSession()) {
    return true;
  }

  const destination = redirects.queryParams.returnUrl || '/dashboard';
  redirects.clear();
  return router.parseUrl(destination);
};

export function currentRouteRequiresAccount(router: Router): boolean {
  const pending = [router.routerState.snapshot.root];
  while (pending.length) {
    const route = pending.pop()!;
    if (route.data[AUTH_REQUIRED] === true) {
      return true;
    }
    pending.push(...route.children);
  }
  return false;
}
